<div class="sidebar">
	<app-sidebar-header [title]="'availability.timeToThink.text.saveThisPrice' | ibeadmin | async" [label]="('availability.timeToThink.text.total' | ibeadmin | async) + ' ' +totalPrice+' '+ currency"></app-sidebar-header>

	<div class="sidebar__body sl--scrollable low-contrast sidebar-size" #sidebar__body>
		<div class="bottom-gap">
			<h2 class="title-h2">{{ 'availability.timeToThink.header.timeToThink' | ibeadmin | async }}</h2>
			<p>{{ 'availability.timeToThink.text.selectWhenYouBuy' | ibeadmin | async }}</p>
		</div>
		<hr class="separator"/>
		<div class="top-gap bottom-gap">
			<div class="passenger" *ngFor="let option of timeToThinkOptions">
				<div class="passenger__details">
					<h3 class="title-h3 passenger__name">{{option.label}}</h3>
				</div>
				<div class="passenger__actions">
					<div class="passenger__action">
						<button class="button" role="alert" [attr.aria-label]="option.value" (click)="INDRA_goTTT(option.code)">
							{{option.value}}
						</button>
					</div>
				</div>
			</div>

		</div>
		<div class="conditions-details ">
		</div>
		<div class="sidebar-flight-text border">
			<p><a class="link extras-feature__link" [attr.aria-label]="'availability.timeToThink.text.closeDialog' | ibeadmin | async"  (click)="INDRA_handleClose()" href="javascript:;"
				role="button">{{ 'availability.timeToThink.text.closeWindow' | ibeadmin | async }}</a></p>
		</div>
	</div>
</div>